__turbopack_context__.v({
  "checkbox": "accessory-card-module-scss-module___KPqkG__checkbox",
  "container": "accessory-card-module-scss-module___KPqkG__container",
  "description": "accessory-card-module-scss-module___KPqkG__description",
  "img": "accessory-card-module-scss-module___KPqkG__img",
  "price": "accessory-card-module-scss-module___KPqkG__price",
  "text": "accessory-card-module-scss-module___KPqkG__text",
});
